import { useEffect, useState } from 'react';
import { PackageCard } from '../components/PackageCard.jsx';
import { fetchFeatured } from '../api/store.js';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { useBasket } from '../context/BasketContext.jsx';
import { usePageTitle } from '../hooks/usePageTitle.js';

export function HomePage() {
  const { site } = useStoreConfig();
  const { rankState } = useBasket();
  const [featured, setFeatured] = useState([]);

  usePageTitle('Welcome');

  useEffect(() => {
    let cancelled = false;


    fetchFeatured(6).then((data) => {
      if (!cancelled) setFeatured(data.packages ?? []);
    });

    return () => {
      cancelled = true;
    };
  }, [rankState]);

  return (
    <main className="content">
      <div className="welcome-card">
        <h2>
          <i className="fa-solid fa-mountain-sun" /> Welcome to {site.name}
        </h2>
        <p>
          All ranks, keys, and cosmetics on offer here support server upkeep, hosting, and ongoing
          development. Most items can also be earned in-game through events, giveaways, and grinding
          — buying is just the express lane.
        </p>
        <p>
          ✨ Thanks for keeping the engines running. Need help? Open a ticket on{' '}
          <a href={site.discord_url} target="_blank" rel="noopener noreferrer">
            <i className="fa-brands fa-discord" /> Discord
          </a>
          .
        </p>

        <div className="payment-banner">
          <i className="fa-solid fa-shield-halved" />
          <span>Secure checkout via Tebex — multiple payment methods supported.</span>
          <div className="payment-icons" aria-hidden="true">
            <i className="fa-brands fa-cc-visa" />
            <i className="fa-brands fa-cc-mastercard" />
            <i className="fa-brands fa-cc-amex" />
            <i className="fa-brands fa-cc-paypal" />
            <i className="fa-brands fa-google-pay" />
            <i className="fa-brands fa-apple-pay" />
          </div>
        </div>
      </div>

      {featured.length > 0 && (
        <div className="welcome-card">
          <div className="section-heading">
            <h2>
              <i className="fa-solid fa-star" /> Featured packages
            </h2>
          </div>
          {}
          <div className="rank-store">
            {featured.map((pkg, index) => (
              <PackageCard key={pkg.id} pkg={pkg} priority={index < 3} />
            ))}
          </div>
        </div>
      )}
    </main>
  );
}
